export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13939.e7d8e4ca.jpg";